import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { useAuth } from '../../../hooks/useAuth';
import { Card, Row, Col, Typography } from 'antd';
import PrintButton from '../../../components/admin/PrintButton';

const { Title, Text } = Typography;

const Overview = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get('/api/stats/general', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setStats(response.data);
      } catch (err) {
        setError('Failed to fetch stats. You might not have the required permissions.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchStats();
    } else {
      setError('Authentication token not found.');
      setLoading(false);
    }
  }, [token]);

  if (loading) {
    return <div>جار التحميل...</div>;
  }

  if (error) {
    return <div style={{ color: 'red' }}>{error}</div>;
  }

  return (
    <div className="container-fluid">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={2}>التقارير والإحصائيات</Title>
        <PrintButton />
      </div>
      {stats && (
        <Card title="الإحصائيات العامة">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Card>
                <Text strong>المستخدمون</Text>
                <Title level={4}>{stats.userCount}</Title>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Card>
                <Text strong>الأنشطة</Text>
                <Title level={4}>{stats.activityLogCount}</Title>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Card>
                <Text strong>المقالات</Text>
                <Title level={4}>{stats.articleCount}</Title>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Card>
                <Text strong>الأقسام</Text>
                <Title level={4}>{stats.sectionCount}</Title>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Card>
                <Text strong>الأخبار</Text>
                <p>المنشورة: {stats.newsCount.published}</p>
                <p>المسودات: {stats.newsCount.draft}</p>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Card>
                <Text strong>التقارير</Text>
                <p>المنشورة: {stats.reportsCount.published}</p>
                <p>المسودات: {stats.reportsCount.draft}</p>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Card>
                <Text strong>رسائل الاتصال</Text>
                <ul>
                  <li>غير مقروءة: {stats.contactMessagesCount.UNREAD}</li>
                  <li>مقروءة: {stats.contactMessagesCount.READ}</li>
                  <li>تم الرد عليها: {stats.contactMessagesCount.REPLIED}</li>
                  <li>مؤرشفة: {stats.contactMessagesCount.ARCHIVED}</li>
                </ul>
              </Card>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};

export default Overview;